import React, {Component} from 'react';
import '../../asset/css/login.css';
import PageContentWallpaper from '../common/ef-pageContent';
import AddingModel from '../common/adding-model';

export default class ComSettingAssetAttribute extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
        this.MyModel = [
            {
                field: "project",
                desc: "Project",
                placeholder: "Project",
                required: false,
                type: "text",
                readonly: false,
                filter: true,
                filterTable: "project",
                filterKey: "name",
                filterValue: "name",
                filterConditionOrgCode:"org"
            },{
                field: "asset",
                desc: "Asset",
                placeholder: "Asset",
                required: false,
                type: "text",
                readonly: false,
                filter: true,
                filterTable: "AssetSetting",
                filterKey: "name",
                filterValue: "name",
                filterConditionOrgCode:"org"
            },
            {
                field: "name",
                desc: "Name",
                placeholder: "name",
                required: true,
                type: "text",
                readonly: false,
                staticValue:""
            },
            {
                field: "Unique",
                desc: "Unique",
                placeholder: "Unique",
                required: true,
                type: "option",
                readonly: false,
                staticValue:"",
                options:[{val:"no",desc:"No"},{val:"yes",desc:"Yes"}]
            },
            {
                field: "Mandatory",
                desc: "Mandatory",
                placeholder: "Mandatory",
                required: true,
                type: "option",
                readonly: false,
                staticValue:"",
                options:[{val:"no",desc:"No"},{val:"yes",desc:"Yes"}]
            },
            {
                field: "UnitOfMeasure",
                desc: "Unit Of Measure",
                placeholder: "Unit Of Measure",
                required: true,
                type: "option",
                readonly: false,
                staticValue:"",
                options:[{val:"no",desc:"No"},{val:"yes",desc:"Yes"}]
            }

        ];

        this.ModelName = "AssetAttribute";
        this.Crum = "/crum";
        this.PrimaryKey = "org"
    }


    render() {
        return (


            <PageContentWallpaper {...this.props} >

                <div className="row">
                    <div className="col-xs-12">
                        <h2>Asset Attribute</h2>
                    </div>

                </div>

                <div className="row">
                    <div className="col-xs-12">
                        <AddingModel
                            MyModel={this.MyModel}
                            ModelName={this.ModelName}
                            ListDisplayKey={["Name","Unique","Mandatory","UnitOfMeasure","Project"]}
                            ListDeleteKey={[
                                {field: this.PrimaryKey, type: "string"},
                                {field: "project", type: "string"},
                                {field: "asset", type: "string"},
                                {field: "name", type: "string"},
                            ]}
                            Crum={this.Crum}
                            PrimaryKey={this.PrimaryKey}
                        />
                    </div>
                </div>


            </PageContentWallpaper>


        );
    }
}